import { camel as camelCase } from "radashi"

import type { FAQ } from "@bounce/web-components"

import type { PreFAQ } from "./boilerplate"

export const getPreFaq = <T>(faqId: string, faqs: FAQ[]): PreFAQ<T> => {
  const { id, question, answer, structuredAnswer } = faqs.find(({ id }) => faqId === id) as FAQ

  return {
    id,
    key: camelCase(id),
    question: () => question,
    answer: () => answer,
    ...(structuredAnswer ? { structuredAnswer: () => structuredAnswer } : {}),
    requires: [],
  }
}
